import React from "react";
import "./AboutUs.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

import visionImage from "../../assets/images/Group 48095511.svg";

import founderImage from "../../assets/images/Founder Pic.jpg";

import linkedInIcon from "../../assets/images/entypo-social_linkedin-with-circle.svg";

import fundOfFundsLogo from "../../assets/images/fb_image 1@2x.png";

import incubatorLogo from "../../assets/images/Screenshot 2022-07-02 at 4.55 1@3x.webp";

import unicornLogo from "../../assets/images/image 2.webp";

import seaFundLogo from "../../assets/images/y9mlz0gbk5b5zeknndtf 1.webp";

const AboutUs: React.FC = () => {
  return (
    <>

    <title>About Finsall Premium Finance Platform</title>
<meta
  name="description"
  content="Learn about Finsall’s mission to simplify premium financing through digital workflows, lender partnerships and insurance ecosystem trust."
/>
      <Header />

      {/* VISION SECTION */}

      <section className="vision-section">
        <div className="vision-container">

          <div className="vision-content">

            <span className="vision-badge">
              Vision
            </span>

            <h1 className="vision-title">
              “About Finsall and Its Premium Financing Platform”
            </h1>

            <p className="vision-description">
              Finsall has pioneered India’s insurance premium financing
              industry. We are determined to maintain our position as
              the most trusted partner for the ecosystem.
            </p>

          </div>

          <div className="vision-image-wrapper">
            <img
              src={visionImage}
              alt="illustration of india with insurance protection and digital coverage icons"
              className="vision-image"
            />
          </div>

        </div>
      </section>

           {/* =========================================
          COUNTER SECTION
      ========================================= */}

      <section className="stats-section">

        <div className="stats-grid">

          <div className="stat-item">
            <h2>15,000+</h2>
            <p>Cities / Towns Serviced</p>
          </div>

          <div className="stat-item">
            <h2>50,000+</h2>
            <p>Intermediaries</p>
          </div>

          <div className="stat-item">
            <h2>8,30,000+</h2>
            <p>Lives Impacted</p>
          </div>

        </div>

      </section>

      {/* FOUNDING TEAM SECTION */}

      <section className="founding-team-section">

        <div className="founding-team-header">

          <h2>
            The Founding Team
          </h2>

          <p>
            Core team brings forth a bold vision backed by exceptional
            execution and operational capability
          </p>

        </div>

        <div className="founder-image-wrapper">

          <img
            src={founderImage}
            alt="founding team standing together"
            className="founder-image"
          />

        </div>

        <div className="founders-grid">

          <div className="founder-card">

            <h3>
              TIM MATHEWS
            </h3>

            <p>
              CO-FOUNDER, CEO
            </p>

            <a
              href="https://www.linkedin.com/in/timmathews"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={linkedInIcon}
                alt="LinkedIn"
                className="linkedin-icon"
              />
            </a>

          </div>

          <div className="founder-card">

            <h3>
              PRABAL KHANNA
            </h3>

            <p>
              CO-FOUNDER, COO
            </p>

            <a
              href="https://www.linkedin.com/in/prabal-khanna-a84b856"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={linkedInIcon}
                alt="LinkedIn"
                className="linkedin-icon"
              />
            </a>

          </div>

          <div className="founder-card">

            <h3>
              PROMOD KHANNA
            </h3>

            <p>
              FOUNDER, DIRECTOR
            </p>

            <a
              href="https://www.linkedin.com/in/promod-khanna-a86a37b"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={linkedInIcon}
                alt="LinkedIn"
                className="linkedin-icon"
              />
            </a>

          </div>

        </div>
      </section>

            {/* FUND OF FUNDS + INCUBATOR */}

      <section className="startup-partners-section">

        <div className="startup-partners-container">

          <div className="startup-partner-card">

            <div className="startup-logo-wrapper">
              <a
                href="https://startupmission.kerala.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={fundOfFundsLogo}
                  alt="kerala startup mission logo"
                  className="startup-logo"
                />
              </a>
            </div>

            <h3>
              FUND OF FUNDS
            </h3>

            <p>
              Part of the family of startups backed by the
              KSUM fund of funds
            </p>

          </div>

          <div className="startup-partner-card">

            <div className="startup-logo-wrapper">
              <a
                href="https://10000startups.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={incubatorLogo}
                  alt="nasscom 10000 startups logo"
                  className="startup-logo"
                />
              </a>
            </div>

            <h3>
              INCUBATOR
            </h3>

            <p>
              Part of the family of startups incubated in the
              NASSCOM 10000 Startup Warehouse program in
              Noida & Bengaluru
            </p>

          </div>

        </div>

      </section>

      {/* INVESTORS */}

      <section className="investors-section">

        <div className="investors-header">

          <h2>
            Our Investors
          </h2>

          <p>
            Our audacious journey is fueled by visionaries
            who have supported Finsall
          </p>

        </div>

        <div className="investors-logos">

          <a
            href="https://www.unicornivc.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={unicornLogo}
              alt="unicorn india ventures logo"
              className="investor-logo unicorn-logo"
            />
          </a>

          <a
            href="https://seafund.in/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={seaFundLogo}
              alt="Sea fund logo"
              className="investor-logo seafund-logo"
            />
          </a>

        </div>

      </section>
      <Footer />
    </>
  );
};

export default AboutUs;